module.exports = __webpack_public_path__ + "media/images/regions/causal_graphs/europe_and_central_asia-8ca1a92d6a5538805812ecbc0578a200.svg";